var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoricRates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7998 11.5C19.7998 15.6421 16.4419 19 12.2998 19C10.1015 19 8.12416 18.0543 6.75236 16.5474L7.46037 15.8394L7.47638 15.8572L7.78346 15.5501C8.89414 16.7878 10.5062 17.5664 12.3001 17.5664C15.6506 17.5664 18.3667 14.8503 18.3667 11.4998C18.3667 8.14924 15.6506 5.43311 12.3001 5.43311C8.94954 5.43311 6.2334 8.14924 6.2334 11.4998C6.2334 11.6004 6.23585 11.7004 6.24069 11.7998H8L5.5 14.2998L3 11.7998H4.80569C4.80178 11.7004 4.7998 11.6004 4.7998 11.5C4.7998 7.35786 8.15767 4 12.2998 4C16.4419 4 19.7998 7.35786 19.7998 11.5Z",
    fill: "#32CFDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2998 8H11.2998V12.8862V12.9H11.3262L15.0765 14.8595L15.5396 13.9732L12.2998 12.2805V8Z",
    fill: "#32CFDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricRates);
export default __webpack_public_path__ + "static/media/historic-rates.722ae0c3.svg";
export { ForwardRef as ReactComponent };